import * as types from '@store/types'
import { assign } from '@/helpers/object'

const feedbackTemplate = {
  type: undefined,
  title: undefined,
  text: undefined,
  icon: undefined
}

const state = {
  feedback: {
    type: '',
    title: '',
    text: '',
    icon: ''
  }
}

const getters = {
  [types.FEEDBACK]: (_) => {
    const feedback = assign(
      'right',
      _.feedback,
      feedbackTemplate
    )

    return feedback
  }
}

const mutations = {
  [types.FEEDBACK]: (state, payload) => {
    state.feedback = { ...payload }
  }
}

const actions = {
  [types.FEEDBACK]: ({ commit }, payload) => {
    commit(types.FEEDBACK, payload)
  },
  [types.FEEDBACK_CLOSE]: ({ commit }) => {
    commit(types.FEEDBACK, feedbackTemplate)
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/feedback.js